export default __webpack_public_path__ + "static/media/screenBlock9.02ae5e1d.jpg";